import { Signal } from '@angular/core';
import { BaseFacade, CommonGenericModel, Filter, Pagination, DeviceCallLog } from '@iot-platform/models/common';

export abstract class AbstractDeviceCallLogsFacade<T extends CommonGenericModel> extends BaseFacade<DeviceCallLog, Pagination, Filter> {
  abstract deviceCallLogMessage: Signal<string>;

  abstract loadDeviceCallLogs(device: T): void;
  abstract loadDeviceCallLogMessage(device: T, deviceCallLog: DeviceCallLog): void;
}
